exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-user-initials{width:38px;height:38px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;border:solid 2px rgb(90.6666666667%,91.3725490196%,93.8823529412%);background-color:#fff;display:flex;justify-content:center;align-items:center;margin-right:12px;position:relative;font-size:16px}.c-user-initials_status{width:9px;height:9px;background-color:#7ed321;border-radius:50%;position:absolute;bottom:-4px;right:-4px}", ""]);

// exports
